import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { UpdateProcessingRuleTiersPayload } from './processingRuleTiers.types';
import { QUERY_KEY as SERVICE_CONFIGS_QUERY_KEY } from './useServiceConfigs.query';

export const useUpdateProcessingRuleTiersQuery = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({
      processingRuleId,
      payload,
    }: {
      processingRuleId: string;
      payload: UpdateProcessingRuleTiersPayload;
    }) => api.patch(API_URL.PROCESSING_RULES_BY_ID(processingRuleId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [SERVICE_CONFIGS_QUERY_KEY],
        });
      },
    }
  );

  return mutation;
};

export default useUpdateProcessingRuleTiersQuery;
